import { eventGetters } from './eventGetters'
import { sanitizeAlgoliaQueryId } from './helpers'
import type {
  EventAddOn,
  EventDate,
  EventDescription,
  Pricings,
} from '~/composables/types/event'
import type { EventDateCartItem } from '~/composables/types/cart'
import { enrichAddOnsForCart } from '~/utils/cartAddOnHelpers'

const parseEventDateToCartItem = (
  event: EventDescription,
  selectedTicketQuantity: Ref<number | undefined> | number,
  pricings: Pricings,
  selectedTime?: Ref<EventDate>,
  selectedAddOns?: Ref<EventAddOn[] | undefined>,
  isPrivate = false,
  queryId = ''
): EventDateCartItem => {
  const privateMaxTickets = eventDateGetters.getPrivateMaxTickets(
    selectedTime.value
  )
  const publicMaxTickets = eventDateGetters.getAvailableTicketsQuantity(
    selectedTime.value
  )

  const availableTickets = isPrivate ? privateMaxTickets : publicMaxTickets

  const qty = Math.min(toValue(selectedTicketQuantity) || 1, availableTickets)

  return {
    type: 'EVENT',
    id: selectedTime.value.id,
    event, // Include full EventDescription for access to pricing categories
    children: selectedTime?.value?.children || [],
    quantity: qty,
    eventDescriptionId: eventGetters.getId(event),
    title: eventGetters.getTitle(event),
    pricings,
    eventDescriptionPricing: event.pricing?.data,
    category: eventGetters.getMainCategory(event) || '',
    permalink: eventGetters.getPermalink(event),
    thumbnail: imageGetters.getThumb(eventGetters.getPrincipalImage(event)),
    requiredAddress: eventGetters.getIsAddressRequired(event) || false,
    availableTicketsQuantity: eventDateGetters.getAvailableTicketsQuantity(
      selectedTime.value
    ),
    privateMinTickets: eventDateGetters.getPrivateMinTickets(
      selectedTime.value
    ),
    privateMaxTickets,
    dateType: eventDateGetters.getDateType(selectedTime.value) || undefined,
    date: eventDateGetters.getStartTime(selectedTime.value),
    startTime: eventDateGetters.getStartTime(selectedTime.value),
    endTime: eventDateGetters.getEndTime(selectedTime.value),
    all_day: selectedTime.value.all_day || false,
    private:
      isPrivate ||
      eventDateGetters.getIsPrivate(selectedTime.value, true) ||
      false,
    dateTypeToBeBooked: isPrivate ? 'PRIVATE' : 'PUBLIC',
    addOn: enrichAddOnsForCart(selectedAddOns?.value, { quantity: qty }),
    queryID: sanitizeAlgoliaQueryId(queryId) || undefined,
    attendanceMode: eventGetters.getAttendanceMode(event),
    hasShippingCosts: eventGetters.hasShippingCosts(event),
    supplier: eventGetters.getSupplierName(event),
    supplierId: eventGetters.getSupplierId(event),
    needsMajority: eventGetters.getNeedsMajority(event),
    specialization: eventGetters.getSpecialization(event),
  }
}

export default parseEventDateToCartItem
